import * as React from 'react';
import useEvent from '@react-hook/event';
export const useKeycode = (which, onKeyDown) => useKeycodes({
  [which]: onKeyDown
});
export const useKeycodes = listeners => {
  const ref = React.useRef(null);
  useEvent(ref, 'keydown', event => {
    var _listeners$event$whic;

    (_listeners$event$whic = listeners[event.which]) === null || _listeners$event$whic === void 0 ? void 0 : _listeners$event$whic.call(listeners, event);
  });
  return ref;
};
export default useKeycode;